import React from 'react';
import AdminLayout from '../../Hocs/Admin_layout';

function Dashboard() {
    return (
        <AdminLayout>

            <div className="user_dashboard">
                <div>This is your dashboard</div>
            </div>
        </AdminLayout>
    )
}

export default Dashboard
